import React, { useState, useEffect, useCallback } from "react";
import i18n from "i18next";
import { ReactComponent as DeductionIcon } from "assets/svg/deduction-list-icon.svg";
import { Notification } from "types/notification";
import { fetchNotifications } from "api";
import moment from "moment";
import { useTranslation } from "react-i18next";

function History() {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const { t } = useTranslation();

  async function getList() {
    const resp = await fetchNotifications({ page: 1, limit: 7 });

    if (resp) {
      setNotifications(resp.items.splice(0, 6));
    }
  }

  useEffect(() => {
    getList();
  }, []);

  const handleLanguageChanged = useCallback(() => {
    getList();
  }, []);

  useEffect(() => {
    i18n.on("languageChanged", handleLanguageChanged);

    return () => {
      i18n.off("languageChanged", handleLanguageChanged);
    };
  }, [handleLanguageChanged]);

  return (
    <div className="p-8 px-12 ">
      <div className="text-[24px]">{t("Последние события")}</div>
      <div className="leading-[36px]">
        {notifications?.length === 0 && (
          <div className="text-[18px] text-slate-400 font-['Fira_sans'] pt-64 text-center">
            {t("Список уведомлений пуст")}
          </div>
        )}
        {!!notifications?.length &&
          notifications?.length > 0 &&
          notifications.map((item) => (
            <HistoryItem key={item.id} item={item} />
          ))}
      </div>
    </div>
  );
}

function HistoryItem({ item }: { item: Notification }) {
  return (
    <div className="grid grid-cols-[32px_minmax(0,1fr)] items-start gap-x-4 gap-y-1 text-[14px] py-8 border-b font-['Fira_sans'] md:grid-cols-[32px_auto_minmax(0,1fr)] md:items-center">
      <div className="row-span-2 flex h-[32px] w-[32px] items-center justify-center self-start rounded-xl bg-green-400 md:row-span-1 md:self-center">
        <DeductionIcon />
      </div>
      <div className="whitespace-nowrap text-slate-400 leading-[32px]">
        {item.createdAt
          ? moment(item.createdAt).format("DD.MM.yyy / hh:mm")
          : "-"}
      </div>
      <div className="col-start-2 min-w-0 break-words leading-[18px] md:col-start-3">
        {item.sentMessage}
      </div>
    </div>
  );
}

export default History;
